import { ChangeEvent, ReactNode } from 'react';
import classNames from 'classnames';

type InputChangeEvent = ChangeEvent<HTMLInputElement>;

type Props = {
  autoFocus?: boolean;
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  group?: string;
  label: string;
  onChange: (val: string) => void;
  option: string;
  value: string;
  variant?: 'primary' | 'secondary';
}

export default function ScaleOptionField({
  children,
  className,
  group = 'default',
  label,
  onChange,
  option,
  value,
  variant = 'primary',
  ...rest
}: Props) {

  const handleChange = (event: InputChangeEvent) => {
    onChange(event.target.value);
  };

  const checked = (value === option);

  const classes = classNames(
    'flex justify-center items-center font-normal text-lg border-2 rounded-full cursor-pointer text-center overflow-hidden relative uppercase w-8 h-8',
    className,
    {
      // Primary
      'border-lightblue': variant === 'primary',
      'bg-lightblue text-white': variant === 'primary' && checked,
      'text-lightblue': variant === 'primary' && !checked,
    },
    {
      // Secondary
      'border-blue': variant === 'secondary',
      'bg-blue text-white': variant === 'secondary' && checked,
      'text-blue': variant === 'secondary' && !checked,
    }
  );

  return (
    <label className={classes} aria-label={label}>
      <input
        checked={checked}
        className="sr-only"
        name={group}
        onChange={handleChange}
        type="radio"
        value={option}
        {...rest}
      />
      {children ? children : label}
    </label>
  );
};
